import { ReactComponent as FaceIconVerySad } from "@icons/face-very-sad.svg";
import { ReactComponent as FaceIconSad } from "@icons/face-sad.svg";
import { ReactComponent as FaceIconNeutral } from "@icons/face-neutral.svg";
import { ReactComponent as FaceIconHappy } from "@icons/face-happy.svg";
import { ReactComponent as FaceIconVeryHappy } from "@icons/face-very-happy.svg";

export const VerySadFace = ({ size }: { size?: string }) => <FaceIconVerySad width={size ?? "48"} height={size ?? "48"} />;
export const SadFace = ({ size }: { size?: string }) => <FaceIconSad width={size ?? "48"} height={size ?? "48"} />;
export const NeutralFace = ({ size }: { size?: string }) => <FaceIconNeutral width={size ?? "48"} height={size ?? "48"} />;
export const HappyFace = ({ size }: { size?: string }) => <FaceIconHappy width={size ?? "48"} height={size ?? "48"} />;
export const VeryHappyFace = ({ size }: { size?: string }) => <FaceIconVeryHappy width={size ?? "48"} height={size ?? "48"} />;
